import axios from 'axios';
import { API_BASE } from '../config';

let onUnauthorizedHandler;

export function createApi(onUnauthorized) {
    onUnauthorizedHandler = onUnauthorized;
    return api;
}

export const api = axios.create({
    baseURL: API_BASE,
    headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token) => {
    failedQueue.forEach((prom) => {
        if (error) prom.reject(error);
        else prom.resolve(token);
    });
    failedQueue = [];
};

api.interceptors.response.use(
    (res) => res,
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 403 && !originalRequest._retry) {
            // Treat 403 as potential token expiry during login/auth
            if (originalRequest.url && originalRequest.url.includes('/login')) {
                return Promise.reject(error);
            }
            error.response.status = 401;
        }
        if (error.response?.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then((token) => {
                        originalRequest.headers.Authorization = `Bearer ${token}`;
                        return api(originalRequest);
                    })
                    .catch((err) => Promise.reject(err));
            }
            originalRequest._retry = true;
            isRefreshing = true;
            const refreshToken = localStorage.getItem('refreshToken');
            if (!refreshToken) {
                localStorage.clear();
                if (onUnauthorizedHandler) onUnauthorizedHandler();
                return Promise.reject(error);
            }
            try {
                const { data } = await axios.post(`${API_BASE}/auth/refresh`, { refresh_token: refreshToken });
                localStorage.setItem('accessToken', data.access_token);
                if (data.refresh_token) {
                    localStorage.setItem('refreshToken', data.refresh_token);
                }
                api.defaults.headers.common.Authorization = `Bearer ${data.access_token}`;
                processQueue(null, data.access_token);
                originalRequest.headers.Authorization = `Bearer ${data.access_token}`;
                return api(originalRequest);
            } catch (err) {
                processQueue(err, null);
                localStorage.clear();
                if (onUnauthorizedHandler) onUnauthorizedHandler();
                return Promise.reject(err);
            } finally {
                isRefreshing = false;
            }
        }
        return Promise.reject(error);
    }
);

export default api;